import config from 'react-global-configuration';

import {
  UI_OPERATION_STATUS_ERROR,
  UI_OPERATION_STATUS_REQUEST,
  UI_OPERATION_STATUS_SUCCESS,
  setOperationStatus,
} from '@uncinc/react-drupal-core';
import { viewGet } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/View';

import { fetchMessages } from '../../Messages';

export const commentAdd = (values) => {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    dispatch(setOperationStatus('comment', 'add', UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(`${PATH}/rest/session/token?_format=json`, {
        credentials: 'include',
      })
        .then((response) => response.text())
        .then((response) => {
          const csrfToken = response;

          fetch(`${PATH}/comment?_format=json`, {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify(values),
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
          })
            .then((response) => {
              if (response.ok) {
                dispatch(setOperationStatus('comment', 'add', UI_OPERATION_STATUS_SUCCESS));

                // Fetch messages for possible new badges.
                dispatch(fetchMessages());

                resolve(response);
              } else {
                throw new Error();
              }
            })
            .catch((error) => {
              dispatch(setOperationStatus('comment', 'add', UI_OPERATION_STATUS_ERROR));
              reject(error);
            });
        })
        .catch((error) => {
          dispatch(setOperationStatus('comment', 'add', UI_OPERATION_STATUS_ERROR));
          reject(error);
        });
    });
  };
};

export const commentAnonymize = (comment_id) => {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    dispatch(setOperationStatus('comment', 'anonymize', UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(`${PATH}/rest/session/token?_format=json`, {
        credentials: 'include',
      })
        .then((response) => response.text())
        .then((response) => {
          const csrfToken = response;

          fetch(`${PATH}/entity/comment/${comment_id}/anonymize?_format=json`, {
            method: 'PATCH',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
          })
            .then((response) => {
              if (response.ok) {
                dispatch(setOperationStatus('comment', 'anonymize', UI_OPERATION_STATUS_SUCCESS));
                resolve(response);
              } else {
                throw new Error();
              }
            })
            .catch((error) => {
              dispatch(setOperationStatus('comment', 'anonymize', UI_OPERATION_STATUS_ERROR));
              reject(error);
            });
        })
        .catch((error) => {
          dispatch(setOperationStatus('comment', 'anonymize', UI_OPERATION_STATUS_ERROR));
          reject(error);
        });
    });
  };
};

export const commentEdit = (cid, values) => {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;
    const currentPage = getState().getIn(['view', 'forum_post_comments', 'default', 'pager', 'current_page'], 0);

    dispatch(setOperationStatus('comment', 'edit', UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(`${PATH}/rest/session/token?_format=json`, {
        credentials: 'include',
      })
        .then((response) => response.text())
        .then((response) => {
          const csrfToken = response;

          fetch(`${PATH}/entity/comment/${cid}?_format=json`, {
            method: 'PATCH',
            credentials: 'include',
            body: JSON.stringify(values),
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error();
              }

              return response.json();
            })
            .then((response) => {
              const nid = response.entity_id[0].target_id;

              dispatch(setOperationStatus('comment', 'edit', UI_OPERATION_STATUS_SUCCESS));

              // Fetch messages for possible new badges.
              dispatch(fetchMessages());

              // Go to the page where the comment is located.
              dispatch(viewGet('forum_post_comments', 'default', currentPage, [nid], {}));

              resolve(response);
            })
            .catch((error) => {
              dispatch(setOperationStatus('comment', 'edit', UI_OPERATION_STATUS_ERROR));
              reject(error);
            });
        })
        .catch((error) => {
          dispatch(setOperationStatus('comment', 'edit', UI_OPERATION_STATUS_ERROR));
          reject(error);
        });
    });
  };
};

export const nodeAnonymize = (node_id, anonymize_comments = false) => {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    dispatch(setOperationStatus('node', 'anonymize', UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(`${PATH}/rest/session/token?_format=json`, {
        credentials: 'include',
      })
        .then((response) => response.text())
        .then((response) => {
          const csrfToken = response;

          fetch(`${PATH}/entity/node/${node_id}/anonymize?_format=json`, {
            method: 'PATCH',
            credentials: 'include',
            body: JSON.stringify({
              anonymize_comments: anonymize_comments,
            }),
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
          })
            .then((response) => {
              if (response.ok) {
                dispatch(setOperationStatus('node', 'anonymize', UI_OPERATION_STATUS_SUCCESS));
                resolve(response);
              } else {
                throw new Error();
              }
            })
            .catch((error) => {
              dispatch(setOperationStatus('node', 'anonymize', UI_OPERATION_STATUS_ERROR));
              reject(error);
            });
        })
        .catch((error) => {
          dispatch(setOperationStatus('node', 'anonymize', UI_OPERATION_STATUS_ERROR));
          reject(error);
        });
    });
  };
};

